/* ========== ~~~~~~~~~~ TRANSILER : CONTENT DATA ~~~~~~~~~~ ========== */
export default {
    data: [
        {
            "id":"rivalFrame1",
            "type":"poll", // quiz, poll, story
            "background":"yahoo/rivals/football/Image1_Quvaris_Crouch.jpeg",
            "backgroundColor": null,
            "queuePosition": 0,
            "answersType":"image1",
            "text":"Question Text",
            "answerSignature": "",
            "questionSignature": "",
            "answers": [
                {
                    "id":"rivalQuestion1Answer1",
                    "text":"Answer 1",
                    "image":"",
                    "emoji":null
                },
                {
                    "id":"rivalQuestion1Answer2",
                    "text":"Answer 2",
                    "image":"",
                    "emoji":null
                },
                {
                    "id":"rivalQuestion1Answer3",
                    "text":"Answer 3",
                    "image":"",
                    "emoji":null
                },
                {
                    "id":"rivalQuestion1Answer4",
                    "text":"Answer 4",
                    "image":"",
                    "emoji":null
                }
            ]
        }
    ]
};
